import React from 'react';

export default function DashboardEconomic(props) {
    return (
        <div className="card border-0 rounded-15px bg-white shadow h-100 px-3">
            <div className="card-body card-widget">
                <div className={'row'}>
                    <div className={'col'}>
                        <h2 className="text-dark-blue">{$t('Economic')}</h2>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col'}>
                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="text-blue bg-white">
                                                <th colSpan={2}>{$t('Return On Investment')}</th>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Total Event Expenditure')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.return_on_investment.total_expenditure)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>
                                                    <div>{$t('Total Direct Event Income')}</div>
                                                    <div>({$t('Non Government')})</div>
                                                </td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.return_on_investment.total_direct_income)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Total Direct Economic Impact')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.return_on_investment.total_direct_economic_impact)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                    <div className="card-body card-widget">
                                        <div className={'d-flex flex-column justify-content-center h-100 px-3'}>
                                            <h3 className={'text-blue mb-2'}>{$t('Direct Return on Investment')}</h3>
                                            <h3 className={'text-blue'}>{props.format(props.data.direct_return_on_investment)} %</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="text-blue bg-white">
                                                <th colSpan={2}>{$t('Analysis')}</th>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Total Indirect Impact')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.analysis.total_indirect_impact)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Total Induced Impact')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.analysis.total_induced_impact)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Total Economic Impact')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.analysis.total_economic_impact)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className={'row h-100 align-items-start'}>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow h-100">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Direct+Indirect ROI')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.direct_indirect_roi)} %</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow h-100">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('All Impact ROI')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.all_impact_roi)} %</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Public sector contribution')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.analysis.public_sector_contribution)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Capital Investment')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.analysis.capital_investment)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className={'row h-100 align-items-start'}>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2 text-capitalize'}>{$t('Public sector contribution')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.public_sector_contribution)} %</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Capital Investment')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.capital_investment)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="text-blue bg-white">
                                                <th colSpan={2}>{$t('Workforce')}</th>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('LOC Paid Headcount')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.workforceData.analysis.loc_paid_headcount)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('% Local')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.workforceData.analysis.loc_paid_headcount_percent_local)} %
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Contractors')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.workforceData.analysis.contractors)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('% Local')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.workforceData.analysis.contractors_percent_local)} %
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className={'row h-100 align-items-center'}>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Full Time Equivalents')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.workforceData.full_time_equivalents)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Local Volunteers')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.workforceData.local_volunteers)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="text-blue bg-white">
                                                <th colSpan={2}>{$t('Event')}</th>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Event Indirect')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>{props.format(props.data.event.total_indirect)}</td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Event Induced')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>{props.format(props.data.event.total_induced)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                    <div className="card-body card-widget">
                                        <div className={'d-flex flex-column justify-content-center h-100 px-3'}>
                                            <h3 className={'text-blue mb-2'}>{$t('Direct Event Impact')}</h3>
                                            <h3 className={'text-blue'}>{props.format(props.data.event.total_direct)}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={'row my-3'}>
                            <div className={'col-12 col-lg-4'}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className={'my-3 key-metrics-table table table-borderless table-sm no-footer'}>
                                        <tbody>
                                            <tr className="text-blue bg-white">
                                                <th colSpan={2}>{$t('Pre and Post Event')}</th>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Pre Total Indirect')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.pre_post.pre.total_indirect)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Pre Total Induced')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.pre_post.pre.total_induced)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Post Total Indirect')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.pre_post.post.total_indirect)}
                                                </td>
                                            </tr>
                                            <tr className="bg-white">
                                                <td className={'text-gray'}>{$t('Post Total Induced')}</td>
                                                <td className={'font-weight-bold text-right text-blue'}>
                                                    {props.format(props.data.pre_post.post.total_induced)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'col-12 col-lg-8'}>
                                <div className={'row h-100 align-items-center'}>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Pre Event Impact')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.pre_post.pre.total)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-12 col-lg-6'}>
                                        <div className="card border-0 rounded-15px bg-white shadow">
                                            <div className="card-body card-widget">
                                                <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                    <h4 className={'text-blue mb-2'}>{$t('Post Event Impact')}</h4>
                                                    <h3 className={'text-blue'}>{props.format(props.data.pre_post.post.total)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
